import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card } from 'sa-ui';
import messages from '../../reportsMessages';
import * as helpers from '../../reportHelpers';
import LoadMore from '../../LoadMore';

import StudentPerformanceSquare from '../../StudentPerformanceSquare';

const StudentsGradeCurricularComponentTable = (props) => {
  const [limit, setLimit] = useState(props.limit);
  return (
    <Card className="students-grade-table">
      <div>
        <h5 className="title mt-0">
          <i className="ti ti-stats-up mr-2" />
          {props.intl.formatMessage(messages.hitPercentageComponentsPerQuestion)}
        </h5>
      </div>
      <div>
        <table className="default-table">
          <thead>
            <tr>
              <th>{props.intl.formatMessage(messages.question)}</th>
              <th>{props.intl.formatMessage(messages.hitPercentage)} (%)</th>
              <th>{props.intl.formatMessage(messages.curricularComponent)}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.slice(0, limit).map((s, index) => (
              <tr>
                <td style={s.canceled ? { textDecoration: 'line-through' } : {}}>
                  {`Q${s.position}`}
                </td>
                <td>
                  <StudentPerformanceSquare
                    percentHits={s.percentHits}
                    color={s.canceled ? '#555555' : helpers.getColor(s.percentHits)}
                    size={50}
                  />
                </td>
                <td style={s.canceled ? { textDecoration: 'line-through' } : {}}>
                  {s.curricularComponent}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {props.data.length > 10 && <LoadMore onClick={() => setLimit(limit + props.limit)} />}
      </div>
    </Card>
  );
};

StudentsGradeCurricularComponentTable.propTypes = {};

StudentsGradeCurricularComponentTable.defaultProps = {
  data: [],
  limit: 10,
};

export default injectIntl(StudentsGradeCurricularComponentTable);
